import styled from 'styled-components';
import { formatDateFromString } from '../../../../../../utils/formatDateFromString';
import ViewDetailsModal from '../ViewDetailsModal';

interface ComponentProps {
  allQuotes: any[];
  setAllQuotes: (v: any[]) => void;
  data: any;
  setViewDetailsModalShow: (v: boolean) => void;
  viewDetailsModalShow: boolean;
}

const SingleQuoteDesktop = ({
  allQuotes,
  setAllQuotes,
  data,
  viewDetailsModalShow,
  setViewDetailsModalShow,
}: ComponentProps) => {
  return (
    <>
      <Wrapper>
        <QuoteDate>{formatDateFromString(data?.createdAt)}</QuoteDate>
        <CompanyName>{data?.companyName}</CompanyName>
        <Email>{data?.email}</Email>
        <Action>
          <ViewButton
            onClick={() => setViewDetailsModalShow(!viewDetailsModalShow)}
          >
            View
          </ViewButton>
        </Action>
      </Wrapper>
      <>
        {!!viewDetailsModalShow && (
          <ViewDetailsModal
            setAllQuotes={setAllQuotes}
            allQuotes={allQuotes}
            data={data}
            setViewDetailsModalShow={setViewDetailsModalShow}
          />
        )}
      </>
    </>
  );
};

export default SingleQuoteDesktop;

// date,name,email,action(view)
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  font-size: 22px;
  font-weight: 600;
  font-family: font-semibold;
  background-color: rgba(93, 165, 237, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: rgb(1, 28, 56);

  &:last-child {
    border-bottom: none;
  }
`;

const QuoteDate = styled.div`
  padding: 10px 5px;
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;
const CompanyName = styled.div`
  padding: 10px 5px;
  width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;

const Email = styled.div`
  padding: 10px 5px;
  width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
`;

const Action = styled.div`
  padding: 10px 5px;
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ViewButton = styled.div<any>`
  background-color: rgb(93, 165, 237);
  padding: 5px 10px;
  border-radius: 3px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 500;
  font-family: font-medium;
  &:hover {
    background-color: rgb(33, 112, 190);
  }
`;
